import { api } from "./api";

export const boxsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBoxs: builder.query({
      query: () => "api/Fin/Boxs",
      providesTags: ["boxs"],
    }),
    addBox: builder.mutation({
      query: (formData) => ({
        url: "api/Fin/Boxs",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["boxs"],
    }),
    editBox: builder.mutation({
      query: (formData) => ({
        url: "api/Fin/Boxs",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["boxs"],
    }),
    deleteBox: builder.mutation({
      query: (boxId) => ({
        url: `api/Fin/Boxs?BoxID=${boxId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["boxs"],
    }),
  }),
});

export const {
  useGetBoxsQuery,
  useAddBoxMutation,
  useEditBoxMutation,
  useDeleteBoxMutation,
} = boxsApi;
